import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect } from "react";
import { ExtraSmallFab } from "../../../Shared/components/Buttons/ExtraSmallFAB";
import { isEmptyDay, toDayCostInfo } from "../../hooks/useMealDay";
import { PaymentDialogActions } from "./PaymentDialogActions";
import { PaymentDialogContent } from "./PaymentDialogContent";
import { usePaymentDialog } from "./usePaymentDialog";
export const PaymentDialog = ({ days, handlePaymentDialogClose, isPaymentDialogOpen, onPaymentComplete, orderId, selectedOrder, recipeIngredientReplacementMode, myMealsConfig, }) => {
    const { breakpoints } = useTheme();
    const isMobile = useMediaQuery(breakpoints.down("sm"), { noSsr: true });
    const { isLoading, isErrorState, paymentComplete, paymentIntentId, paymentProcessor, paymentMethod, giftCard, balance, canBalanceBePaid, handleConfirmClick, calculateOrderTotal, clearState, } = usePaymentDialog();
    useEffect(() => {
        let mounted = true;
        if (mounted) {
            if (isPaymentDialogOpen && days.length > 0 && orderId) {
                const dayCostInfos = days
                    .filter((day) => !isEmptyDay(day))
                    .map((day) => {
                    return toDayCostInfo(day, recipeIngredientReplacementMode);
                });
                const model = {
                    Days: dayCostInfos,
                    OrderId: orderId,
                    Order: selectedOrder,
                };
                calculateOrderTotal(model);
            }
        }
        return () => {
            mounted = false;
        };
    }, [isPaymentDialogOpen, orderId]);
    const onClose = (_, reason) => {
        if (reason !== "backdropClick") {
            clearState();
            handlePaymentDialogClose();
        }
    };
    useEffect(() => {
        //no charge so continue saving order changes
        if (balance && balance.remainingBalance <= 0) {
            handleConfirmClick({
                days,
                orderId,
                chargeForOrderUpdates: true,
                paymentMethodId: paymentMethod ? paymentMethod.id : undefined,
                recipeIngredientReplacementMode,
                paymentProcessor,
                paymentIntentId,
                giftCardId: giftCard === null || giftCard === void 0 ? void 0 : giftCard.id,
            }, onPaymentComplete);
        }
    }, [balance]);
    return (_jsxs(Dialog, Object.assign({ open: isPaymentDialogOpen, maxWidth: isMobile ? false : "sm", fullWidth: true, fullScreen: isMobile, onClose: (event, reason) => onClose(event, reason), disableEscapeKeyDown: true, "aria-labelledby": "form-dialog-title" }, { children: [_jsx(DialogTitle, { children: _jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center" }, { children: [_jsx(Typography, Object.assign({ variant: "h3", color: "primary" }, { children: myMealsConfig.PaymentDialogTitle })), _jsx(ExtraSmallFab, { icon: CloseIcon, "aria-label": "close", onClick: (event) => onClose(event, undefined) })] })) }), _jsx(DialogContent, Object.assign({ dividers: true }, { children: _jsx(PaymentDialogContent, { loading: isLoading, error: isErrorState, paymentComplete: paymentComplete, remainingBalance: balance === null || balance === void 0 ? void 0 : balance.remainingBalance }) })), _jsx(DialogActions, { children: _jsx(PaymentDialogActions, { loading: !!isLoading, error: !!isErrorState, paymentComplete: paymentComplete, canBalanceBePaid: canBalanceBePaid, myMealsConfig: myMealsConfig, onClose: onClose, handleConfirmClick: () => handleConfirmClick({
                        days,
                        orderId,
                        chargeForOrderUpdates: true,
                        paymentMethodId: paymentMethod ? paymentMethod.id : undefined,
                        recipeIngredientReplacementMode,
                        paymentProcessor,
                        paymentIntentId,
                        giftCardId: giftCard === null || giftCard === void 0 ? void 0 : giftCard.id,
                    }, onPaymentComplete) }) })] })));
};
